module.exports = __webpack_public_path__ + "img/android-icon-w.4a13a6ea.svg";